import { combineEpics } from 'redux-observable';
import { filter, from, map, of, switchMap, withLatestFrom } from 'rxjs';

import actions from './subcatalogs.actions';
import selectors from './subcatalogs.selectors';
import * as subcatalogAPI from './subcatalogs.api';

import { catchAndLogError } from 'utils/common';

import type { Epic } from 'redux-observable';
import type { Action } from '@reduxjs/toolkit';
import type { RootState } from 'store/wos_store';
import type { LGRootState } from 'store/link_generator_store';

const { fetchSubcatalogs } = actions;

/**
 * Performs the fetch for subcatalogs/products
 *
 * Responds with the values in state if already fetched
 */
export const fetchSubcatalogsEpic: Epic<Action, Action, RootState | LGRootState> = (
  action$,
  state$
) =>
  action$.pipe(
    filter(fetchSubcatalogs.pending.match),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) => {
      const catalogId = payload;
      const subcatalogs = selectors.allByCatalogId(state)[catalogId];

      if (subcatalogs) {
        return of(fetchSubcatalogs.fulfilled(null));
      }

      return from(subcatalogAPI.allByCatalogId(catalogId)).pipe(
        map((subcatalogs) => ({ subcatalogs, catalogId })),
        map(fetchSubcatalogs.fulfilled),
        catchAndLogError(fetchSubcatalogs.rejected())
      );
    })
  );

const combined = combineEpics(fetchSubcatalogsEpic);
export default combined;
